import { render } from "./CatalogEntryMenu.vue?vue&type=template&id=41f6fca6"
import script from "./CatalogEntryMenu.vue?vue&type=script&lang=js"
export * from "./CatalogEntryMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__